import { useEffect, useState, useMemo } from "react";
import {
	Edit,
	useNotify,
	TextInput,
	useGetList,
	SimpleForm,
	useRedirect,
	useTranslate,
	TranslatableInputs,
	NumberInput,
	useUpdate,
	useGetOne,
	SelectInput,
	DateTimeInput,
	BooleanInput,
} from "react-admin";
import { userPreferences } from "../../utils/fakeUserPrefrences";
import { CustomToolbar } from "../../customComponents/CustomToolbar";
import { validatePeerSupportGroupData } from "./peerSupportGroupValidate";
import { useGroupSessionFeedbackSurveys } from "../../customHooks/customHooks";

export const PeerSupportGroupEdit = (props) => {
	const { data = {}, loading } = useGetOne("peer-support-groups", props.id);
	const [languagesArray, setLanguagesArray] = useState([]);
	const [update] = useUpdate("peer-support-groups", props.id);

	const notify = useNotify();
	const redirect = useRedirect();
	const translate = useTranslate();

	const { data: languagesData } = useGetList("languages");
	const { surveys: feedbackSurveys } = useGroupSessionFeedbackSurveys();

	useEffect(() => {
		setLanguagesArray(
			Object.values(languagesData).map((language) =>
				language.name.slice(0, 2).toLowerCase()
			)
		);
	}, [languagesData]);

	const defaultLocale = useMemo(
		() => userPreferences.defaultTranslationLanguage,
		[]
	);

	const reminderHourChoices = [
		{ id: 1, name: "1 hour" },
		{ id: 6, name: "6 hours" },
		{ id: 12, name: "12 hours" },
		{ id: 24, name: "24 hours" },
		{ id: 36, name: "36 hours" },
		{ id: 48, name: "48 hours" },
	];

	const onSuccess = () => {
		notify(translate("peerSupportGroups.edit.success"), "info");
		redirect("/peer-support-groups");
	};

	const onFailure = (error) => {
		notify(error.message || translate("peerSupportGroups.edit.fail"), "warning");
	};

	if (loading) return null;

	return (
		<Edit
			{...props}
			title={translate("peerSupportGroups.edit.title")}
		>
			<SimpleForm
				toolbar={<CustomToolbar />}
				validate={validatePeerSupportGroupData}
				save={(data) => {
					update(
						{ payload: { data } },
						{
							onSuccess,
							onFailure,
						}
					);
				}}
			>
				<TranslatableInputs
					locales={languagesArray}
					defaultLocale={defaultLocale}
				>
					<TextInput source="title" />
					<TextInput source="description" multiline />
					<TextInput source="topic" />
				</TranslatableInputs>
				<DateTimeInput source="sessionDatetime" />
				<TextInput
					source="sessionLink"
					label="Session Link"
				/>
				<NumberInput source="minSpots" min={1} />
				<NumberInput source="maxSpots" min={1} />
				<SelectInput
					source="reminderHoursBefore"
					choices={reminderHourChoices}
				/>
				<SelectInput
					source="feedbackSurveyId"
					choices={feedbackSurveys}
					optionText="name"
					optionValue="id"
				/>
				<DateTimeInput source="feedbackSurveyTime" />
				<BooleanInput source="isActive" />
			</SimpleForm>
		</Edit>
	);
};
